import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [roleLabel, setRoleLabel] = useState("");
  const [loading, setLoading] = useState(true);

  const STAFF = new Set([
    "super_admin", "managing_director", "operations_manager", "logistics_coordinator",
    "fleet_manager", "warehouse_manager", "finance_manager", "customer_service",
  ]);

  const refresh = async () => {
    const token = localStorage.getItem("ebik_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setRoleLabel(data.role_label);
    } catch {
      localStorage.removeItem("ebik_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = (token, u) => {
    localStorage.setItem("ebik_token", token);
    setUser(u);
    refresh();
  };
  const logout = () => {
    localStorage.removeItem("ebik_token");
    setUser(null);
  };

  const isStaff = user && STAFF.has(user.role);
  const isDriver = user && user.role === "driver";

  return (
    <AuthContext.Provider value={{ user, roleLabel, loading, login, logout, isStaff, isDriver, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
